import * as Yup from 'yup';

export const ReUploadDriverInfoSchema = Yup.object().shape({
  profilePicture: Yup.mixed().nullable().optional(),
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  nin: Yup.string()
    .required('NIN is required')
    .length(11, 'NIN must be exactly 11 digits'),
  dateOfBirth: Yup.string().required('Date of birth is required'),
});

export interface ReUploadDriverInfoDataType {
  profilePicture: File | null;
  firstName: string;
  lastName: string;
  nin: string;
  dateOfBirth: string;
}

export const ReUploadDriverInfoInitialValues: ReUploadDriverInfoDataType = {
  profilePicture: null,
  firstName: '',
  lastName: '',
  nin: '',
  dateOfBirth: '',
};

export interface ReUploadDriverInfoInterface {
  profilePicture: File | null;
  firstName: string;
  lastName: string;
  nin: string;
  dateOfBirth: string;
}
